import type { HealthStatus } from '@/types';

interface HealthBadgeProps {
  status: HealthStatus;
  message: string;
}

const statusConfig: Record<HealthStatus, { color: string; label: string; dot: string }> = {
  healthy: {
    color: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400',
    label: 'Healthy',
    dot: 'bg-green-500',
  },
  degraded: {
    color: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400',
    label: 'Degraded',
    dot: 'bg-yellow-500',
  },
  error: {
    color: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400',
    label: 'Error',
    dot: 'bg-red-500',
  },
  unconfigured: {
    color: 'bg-gray-100 text-gray-600 dark:bg-gray-900/30 dark:text-gray-400',
    label: 'Not Configured',
    dot: 'bg-gray-400',
  },
  unknown: {
    color: 'bg-gray-100 text-gray-600 dark:bg-gray-900/30 dark:text-gray-400',
    label: 'Unknown',
    dot: 'bg-gray-400',
  },
};

export function HealthBadge({ status, message }: HealthBadgeProps) {
  const config = statusConfig[status] || statusConfig.unknown;

  return (
    <div
      className={`flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium ${config.color}`}
      title={message}
    >
      <span className={`h-2 w-2 rounded-full ${config.dot}`} />
      {config.label}
    </div>
  );
}
